import { render } from "./SimpleRank2.vue?vue&type=template&id=e8b6180e&scoped=true"
import script from "./SimpleRank2.vue?vue&type=script&lang=js"
export * from "./SimpleRank2.vue?vue&type=script&lang=js"

import "./SimpleRank2.vue?vue&type=style&index=0&id=e8b6180e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b6180e"],['__file',"src/components/h5/board/SimpleRank2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8b6180e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8b6180e', __exports__)) {
    api.reload('e8b6180e', __exports__)
  }
  
  module.hot.accept("./SimpleRank2.vue?vue&type=template&id=e8b6180e&scoped=true", () => {
    api.rerender('e8b6180e', render)
  })

}


export default __exports__